import React from "react";
import me from "../../assets/home/me1.png";

const About = () => {
  return (
    <section className="about section" id="about">
      <div className="about__container container">
        <div className="about__content-wrapper">
          {/* Left: Dramatic Profile Image */}
          <div className="about__image-side">
            <div className="about__image-glow"></div>
            <img src={me} alt="Ahad Ali" className="about__img" />
          </div>

          {/* Right: High-Impact Text Content */}
          <div className="about__text-side">
            <h2 className="about__title-master">Meet the Mastermind </h2>

            <div className="about__bio">
              <p>
                Hi, I'm Ahad. I'm a <b>Full-Stack Engineer</b> and
                top-performing CS graduate (CGPA 3.69) specializing in providing{" "}
                <b>single-point ownership</b> for the entire product lifecycle.
              </p>
              <p>
                From pixel-perfect <b>Figma designs</b> to scalable{" "}
                <b>AI-powered backends</b>, I've shipped 5+ MVPs and mentored
                50+ students. I bridge the gap between technical depth and
                business goals.
              </p>
            </div>

            <div className="about__creative">
              <span className="creative-title">BEHIND THE CODE:</span>
              <p className="creative-text">
                When I'm not architecting systems, you'll usually find me
                <b> winning hackathons</b>, exploring the frontiers of
                <b> AI automation</b>, or <b>mentoring</b> the next generation
                of developers. I'm driven by the thrill of turning complex
                problems into elegant, high-converting digital products.
              </p>
            </div>

            <div className="about__footer-links">
              <span className="find-me">FIND ME ON:</span>
              <div className="social-pill-group">
                <a
                  href="https://linkedin.com/in/ahadalireach"
                  target="_blank"
                  rel="noreferrer"
                  className="social-pill"
                >
                  LINKEDIN
                </a>
                <a
                  href="https://github.com/ahadalireach"
                  target="_blank"
                  rel="noreferrer"
                  className="social-pill"
                >
                  GITHUB
                </a>
                <a
                  href="https://wa.me/923241441444"
                  target="_blank"
                  rel="noreferrer"
                  className="social-pill"
                >
                  WHATSAPP
                </a>
                <a
                  href="mailto:ahadali.reach@gmail.com"
                  target="_blank"
                  rel="noreferrer"
                  className="social-pill"
                >
                  EMAIL
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
